<main class="main" fxLayout="column" [ngClass]="networkClass" fxFlex="auto" [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''">
  <router-outlet #o="outlet"></router-outlet>
</main>
